"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectViewQuestionInfo = exports.selectQuestions = exports.selectQuestionnaireProgress = exports.selectQuestionnaireAnswers = exports.selectMetadata = exports.selectIsBudgetAdjusted = exports.selectHandsetSearchList = exports.selectCurrentSelections = exports.selectCurrentQuestionIndex = exports.selectCurrentQuestion = exports.selectBudget = void 0;
var _widgetSelectors = require("../widget/widgetSelectors");
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _utils = require("../../utils/utils");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var selectQuestions = function selectQuestions(state) {
  return state.drools.questionnaire.questions;
};
exports.selectQuestions = selectQuestions;
var selectQuestionnaireProgress = function selectQuestionnaireProgress(state) {
  var questions = selectQuestions(state);
  var currentQuestion = selectCurrentQuestion(state);
  var currentQuestionIndex = selectCurrentQuestionIndex(state);
  return (0, _questionnaireUtil.getProgressPercentage)(questions, currentQuestion, currentQuestionIndex);
};
exports.selectQuestionnaireProgress = selectQuestionnaireProgress;
var selectCurrentQuestion = function selectCurrentQuestion(state) {
  var questions = selectQuestions(state);
  var currentQuestionIndex = state.drools.questionnaire.currentQuestionIndex;
  return questions[currentQuestionIndex];
};
exports.selectCurrentQuestion = selectCurrentQuestion;
var selectViewQuestionInfo = function selectViewQuestionInfo(state) {
  var questions = selectQuestions(state);
  var viewQuestionIndex = state.drools.questionnaire.viewQuestionIndex;
  return {
    question: questions[viewQuestionIndex],
    index: viewQuestionIndex
  };
};
exports.selectViewQuestionInfo = selectViewQuestionInfo;
var selectCurrentSelections = function selectCurrentSelections(state) {
  var _state$drools$questio = state.drools.questionnaire,
    selections = _state$drools$questio.selections,
    currentQuestionIndex = _state$drools$questio.currentQuestionIndex;
  return selections[currentQuestionIndex] || [];
};
exports.selectCurrentSelections = selectCurrentSelections;
var selectMetadata = function selectMetadata(state) {
  var questionnaire = state.drools.questionnaire;
  var defaultMetadata = (0, _utils.clone)((0, _widgetSelectors.selectDefaultMetadata)(state));
  var metadata = (0, _questionnaireUtil.transformDefaultMetadata)(defaultMetadata);
  if (questionnaire.answers.length === 0) {
    return metadata;
  }
  var lastAnswer = questionnaire.answers[questionnaire.answers.length - 1];
  return (0, _deepmerge.default)(metadata, lastAnswer.metadata, {
    arrayMerge: function arrayMerge(destinationArray, sourceArray) {
      return sourceArray;
    }
  });
};
exports.selectMetadata = selectMetadata;
var selectCurrentQuestionIndex = function selectCurrentQuestionIndex(state) {
  return state.drools.questionnaire.currentQuestionIndex;
};
exports.selectCurrentQuestionIndex = selectCurrentQuestionIndex;
var selectHandsetSearchList = function selectHandsetSearchList(state) {
  return state.drools.questionnaire.handsetSearchList;
};
exports.selectHandsetSearchList = selectHandsetSearchList;
var selectQuestionnaireAnswers = function selectQuestionnaireAnswers(state) {
  return state.drools.questionnaire.answers;
};
exports.selectQuestionnaireAnswers = selectQuestionnaireAnswers;
var selectBudget = function selectBudget(state) {
  return state.drools.questionnaire.budget;
};
exports.selectBudget = selectBudget;
var selectIsBudgetAdjusted = function selectIsBudgetAdjusted(state) {
  return state.drools.questionnaire.isBudgetAdjusted;
};
exports.selectIsBudgetAdjusted = selectIsBudgetAdjusted;